module.exports = __webpack_public_path__ + "static/media/logoutf3248bc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sidenav/images/logout.svg
// module id = 1234
// module chunks = 0